import { useParams } from 'react-router-dom'

import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import {
  useGetMetaAdsCampaignByIdQuery,
  useUpdateMetaAdsCampaignMutation,
} from 'src/Redux/adsCampaignApi'
import { useGenresAndLanguagesAnalytics } from 'src/Hooks/useGenresAndLanguagesAnalytics'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'

import { GenreWithoutCurators } from '../components/AdsGenresModalContent/helpers'

type SaveGenres = (selectedGenres: GenreWithoutCurators[]) => void

export const useSaveGenres = (): SaveGenres => {
  const { number: id } = useParams<{ number: string }>()
  const { data } = useGetMetaAdsCampaignByIdQuery(Number(id))
  const { handleGenreAddedEvent } = useGenresAndLanguagesAnalytics()
  const { setSearch } = useCustomSearchParams()

  const [updateMetaAdsCampaign] = useUpdateMetaAdsCampaignMutation()

  return (selectedGenres: GenreWithoutCurators[]): void => {
    if (!id) {
      return
    }
    updateMetaAdsCampaign({
      id: Number(data?.id),
      genres: selectedGenres
        .map((el) => el.id)
        .filter((genreId): genreId is string => typeof genreId !== 'undefined'),
    })
      .unwrap()
      .then(() => {
        handleGenreAddedEvent({
          platformName: CampaignPlatformTypeEnum.META,
          genreId: selectedGenres.map((el) => String(el.genreName)).join(),
          genreName: selectedGenres.map((el) => String(el.genreName)).join(),
        })
        setSearch({ modal: null })
      })
  }
}
